import { render, staticRenderFns } from "./TypoBuehne.vue?vue&type=template&id=801b5c18&scoped=true"
import script from "./TypoBuehne.vue?vue&type=script&lang=js"
export * from "./TypoBuehne.vue?vue&type=script&lang=js"
import style0 from "./TypoBuehne.vue?vue&type=style&index=0&id=801b5c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801b5c18",
  null
  
)

export default component.exports